/* eslint-disable */

// This file was automatically generated by graphql-codegen. Do not edit this directly.

export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: string;
};

export type Access = {
  __typename?: 'Access';
  canModerate?: Maybe<Scalars['Int']>;
  communityId?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['String']>;
  for?: Maybe<Scalars['String']>;
  forId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  type?: Maybe<Scalars['String']>;
  typeId?: Maybe<Scalars['ID']>;
};

export type AccessComments = {
  __typename?: 'AccessComments';
  attachmentsEnabled: Scalars['Boolean'];
  enabled: Scalars['Boolean'];
};

export type AccessCommentsInput = {
  attachmentsEnabled: Scalars['Boolean'];
  enabled: Scalars['Boolean'];
};

export type AccessInput = {
  canModerate: Scalars['Boolean'];
  id?: Maybe<Scalars['String']>;
  typeId: Scalars['String'];
};

export type AccessOption = {
  __typename?: 'AccessOption';
  groups?: Maybe<Array<UserGroupWithModerationStatus>>;
  options: ChallengeVisibility;
  users?: Maybe<Array<UserWithModerationStatus>>;
};

export type AccessOptionInput = {
  groups: Array<AccessInput>;
  options: ChallengeVisibilityInput;
  users: Array<AccessInput>;
};

export enum AccountProviderType {
  AZURE = 'AZURE',
  FACEBOOK = 'FACEBOOK',
  GOOGLE = 'GOOGLE',
  GOOGLEP = 'GOOGLEP',
  LINKEDIN = 'LINKEDIN',
  MEC = 'MEC',
  SAML2 = 'SAML2',
  SLACK = 'SLACK',
  SSOPROXY = 'SSOPROXY',
  TEAMS = 'TEAMS',
  TWITTER = 'TWITTER',
  YAMMER = 'YAMMER'
}

export type ApiClient = {
  __typename?: 'ApiClient';
  authEndPoint?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  password?: Maybe<Scalars['String']>;
  requestId?: Maybe<Scalars['ID']>;
  secret?: Maybe<Scalars['String']>;
  status: ApiClientStatusType;
  userId: Scalars['ID'];
};

export type ApiClientInput = {
  authEndPoint?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  regeneratePassword: Scalars['Boolean'];
  requestId: Scalars['String'];
};

export enum ApiClientStatusType {
  ACTIVE = 'ACTIVE',
  LOCKED = 'LOCKED',
  REMOVED = 'REMOVED'
}

export type ApiRequest = {
  __typename?: 'ApiRequest';
  applied: Scalars['DateTime'];
  client?: Maybe<ApiClient>;
  communityId: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
  status: ApiRequestStatusType;
  userId: Scalars['String'];
};

export type ApiRequestInput = {
  description: Scalars['String'];
};

export enum ApiRequestStatusType {
  APPLIED = 'APPLIED',
  APPROVED = 'APPROVED',
  REFUSED = 'REFUSED'
}

export type Badge = {
  __typename?: 'Badge';
  actionType?: Maybe<Scalars['String']>;
  auto?: Maybe<Scalars['Boolean']>;
  badges?: Maybe<Array<Badge>>;
  communityId?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creatorId?: Maybe<Scalars['ID']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageFile?: Maybe<File>;
  imageId?: Maybe<Scalars['String']>;
  imageType?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  ruleAmount?: Maybe<Scalars['Int']>;
  ruleChallengeId?: Maybe<Scalars['ID']>;
  ruleMilestoneId?: Maybe<Scalars['ID']>;
  rulePhaseId?: Maybe<Scalars['ID']>;
  score: Scalars['Int'];
  sourceType?: Maybe<Scalars['String']>;
  stockImage?: Maybe<Scalars['String']>;
  visible?: Maybe<Scalars['Boolean']>;
};

export type BadgeWithCountType = {
  __typename?: 'BadgeWithCountType';
  actionType?: Maybe<Scalars['String']>;
  auto?: Maybe<Scalars['Boolean']>;
  badges?: Maybe<Array<Badge>>;
  communityId?: Maybe<Scalars['ID']>;
  count: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  creatorId?: Maybe<Scalars['ID']>;
  dateAwarded: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageFile?: Maybe<File>;
  imageId?: Maybe<Scalars['String']>;
  imageType?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  ruleAmount?: Maybe<Scalars['Int']>;
  ruleChallengeId?: Maybe<Scalars['ID']>;
  ruleMilestoneId?: Maybe<Scalars['ID']>;
  rulePhaseId?: Maybe<Scalars['ID']>;
  score: Scalars['Int'];
  sourceType?: Maybe<Scalars['String']>;
  stockImage?: Maybe<Scalars['String']>;
  totalScore: Scalars['Int'];
  visible?: Maybe<Scalars['Boolean']>;
};

export type BlogPost = {
  __typename?: 'BlogPost';
  communityId: Scalars['ID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  files?: Maybe<IdeaFiles>;
  id: Scalars['ID'];
  stats?: Maybe<BlogPostStats>;
  text?: Maybe<Scalars['String']>;
  theme?: Maybe<Theme>;
  title?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  views?: Maybe<Scalars['Int']>;
};

export type BlogPostFollow = {
  __typename?: 'BlogPostFollow';
  blogPostId: Scalars['ID'];
  id: Scalars['ID'];
  userId: Scalars['ID'];
};

export type BlogPostStats = {
  __typename?: 'BlogPostStats';
  comments: Scalars['Int'];
  followers: Scalars['Int'];
  views?: Maybe<Scalars['Int']>;
  votes?: Maybe<Scalars['Int']>;
};

export type Challenge = {
  __typename?: 'Challenge';
  access?: Maybe<AccessOption>;
  archived?: Maybe<Scalars['Int']>;
  categories?: Maybe<Array<GlobalCategoryWithAssignedField>>;
  communityId: Scalars['String'];
  config: ChallengeConfig;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['ID']>;
  customHeadings?: Maybe<Scalars['String']>;
  daysLimit?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  fileId?: Maybe<Scalars['ID']>;
  files?: Maybe<ChallengeFiles>;
  headerFileId?: Maybe<Scalars['ID']>;
  headings: ChallengeCustomHeadings;
  id: Scalars['ID'];
  ideas?: Maybe<Array<Idea>>;
  ideasHaveVotes?: Maybe<Scalars['Boolean']>;
  isFunnel?: Maybe<Scalars['Boolean']>;
  isMilestone?: Maybe<Scalars['Boolean']>;
  isPrivateSubmission?: Maybe<Scalars['Boolean']>;
  isUserCreated?: Maybe<Scalars['Boolean']>;
  lastProcessedPhase?: Maybe<Scalars['Int']>;
  lastScorecardUpdate?: Maybe<Scalars['DateTime']>;
  longDescription?: Maybe<Scalars['String']>;
  milestone?: Maybe<ChallengeMilestone>;
  milestones?: Maybe<Array<Milestone>>;
  milestonesResetTime?: Maybe<Scalars['Int']>;
  options?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  phases?: Maybe<Array<Phase>>;
  phaseStats?: Maybe<Scalars['String']>;
  questions?: Maybe<Array<ChallengeQuestion>>;
  scorecardLabels?: Maybe<Array<ScorecardLabel>>;
  scorecards?: Maybe<Array<Scorecard>>;
  showInCarousels?: Maybe<Scalars['Boolean']>;
  stats?: Maybe<ChallengeStats>;
  subtitle?: Maybe<Scalars['String']>;
  themes: Array<Theme>;
  title: Scalars['String'];
  translations?: Maybe<Array<Translation>>;
  type?: Maybe<Scalars['Int']>;
  voting?: Maybe<Voting>;
  walletLastUpdate?: Maybe<Scalars['DateTime']>;
};

export type ChallengeCategory = {
  __typename?: 'ChallengeCategory';
  challengeId: Scalars['ID'];
  globalCategoryId: Scalars['ID'];
  id: Scalars['ID'];
};

export type ChallengeConfig = {
  __typename?: 'ChallengeConfig';
  hideUploadFiles?: Maybe<Scalars['Boolean']>;
  ideaDescriptionCharacterLimit?: Maybe<Scalars['Int']>;
  ideaDescriptionType?: Maybe<Scalars['String']>;
  showInCarousels?: Maybe<Scalars['Boolean']>;
  sorting: ChallengeSorting;
  textThemeName?: Maybe<Scalars['String']>;
  themeRequired: Scalars['Boolean'];
};

export type ChallengeConfigInput = {
  hideUploadFiles?: Maybe<Scalars['Boolean']>;
  ideaDescriptionCharacterLimit?: Maybe<Scalars['Int']>;
  ideaDescriptionType?: Maybe<Scalars['String']>;
  showInCarousels?: Maybe<Scalars['Boolean']>;
  sorting: ChallengeSortingInput;
  textThemeName?: Maybe<Scalars['String']>;
  themeRequired: Scalars['Boolean'];
};

export type ChallengeCustomHeadings = {
  __typename?: 'ChallengeCustomHeadings';
  ideaDescriptionHeading: Scalars['String'];
  ideaDescriptionInfoHeading: Scalars['String'];
  ideaFilesHeading: Scalars['String'];
  ideaTitleHeading: Scalars['String'];
  ideaTitleInfoHeading: Scalars['String'];
  themeSelectHeading: Scalars['String'];
};

export type ChallengeCustomHeadingsInput = {
  ideaDescriptionHeading: Scalars['String'];
  ideaDescriptionInfoHeading: Scalars['String'];
  ideaFilesHeading: Scalars['String'];
  ideaTitleHeading: Scalars['String'];
  ideaTitleInfoHeading: Scalars['String'];
  themeSelectHeading: Scalars['String'];
};

export type ChallengeFiles = {
  __typename?: 'ChallengeFiles';
  attachments?: Maybe<Array<File>>;
  header?: Maybe<File>;
  list?: Maybe<File>;
};

export type ChallengeFilesInput = {
  attachments?: Maybe<Array<FileInput>>;
  header?: Maybe<FileInput>;
  list?: Maybe<FileInput>;
};

export type ChallengeFollow = {
  __typename?: 'ChallengeFollow';
  challengeId: Scalars['ID'];
  id: Scalars['ID'];
  include?: Maybe<Scalars['String']>;
  lastUpdate?: Maybe<Scalars['DateTime']>;
  specific?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
};

export enum ChallengeFollowIncludeType {
  ALL = 'ALL',
  SPECIFIC = 'SPECIFIC',
  THEMES_ONLY = 'THEMES_ONLY'
}

export enum ChallengeFollowType {
  DAILY = 'DAILY',
  INSTANT = 'INSTANT',
  WEEKLY = 'WEEKLY'
}

export type ChallengeInput = {
  access?: Maybe<AccessOptionInput>;
  archived: Scalars['Int'];
  categories?: Maybe<Array<GlobalCategoryWithAssignedFieldInput>>;
  config: ChallengeConfigInput;
  daysLimit?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  files?: Maybe<ChallengeFilesInput>;
  headings: ChallengeCustomHeadingsInput;
  id: Scalars['String'];
  isFunnel: Scalars['Boolean'];
  isMilestone: Scalars['Boolean'];
  isPrivateSubmission?: Maybe<Scalars['Boolean']>;
  longDescription?: Maybe<Scalars['String']>;
  milestone?: Maybe<MilestoneInput>;
  options?: Maybe<Scalars['String']>;
  phases?: Maybe<Array<PhaseInput>>;
  questions?: Maybe<Array<ChallengeQuestionInput>>;
  subtitle?: Maybe<Scalars['String']>;
  template?: Maybe<ChallengeTemplateInput>;
  themes?: Maybe<Array<ThemeInput>>;
  title: Scalars['String'];
  translations?: Maybe<Array<TranslationInput>>;
  voting?: Maybe<VotingInput>;
};

export type ChallengeLog = {
  __typename?: 'ChallengeLog';
  action?: Maybe<Scalars['String']>;
  actionFromTable?: Maybe<Scalars['String']>;
  challengeId?: Maybe<Scalars['Int']>;
  communityId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  phaseId?: Maybe<Scalars['Int']>;
  postId?: Maybe<Scalars['Int']>;
  processed?: Maybe<Scalars['Int']>;
  processedDate: Scalars['DateTime'];
  voteId?: Maybe<Scalars['Int']>;
};

export type ChallengeMilestone = {
  __typename?: 'ChallengeMilestone';
  completeMessageToAuthors?: Maybe<Scalars['String']>;
  completeMessageToUsers?: Maybe<Scalars['String']>;
  daysLimit?: Maybe<Scalars['String']>;
  milestoneRejectedIdeaIds?: Maybe<Array<Scalars['String']>>;
  milestones?: Maybe<Array<Milestone>>;
  timeLimitEnabled?: Maybe<Scalars['Boolean']>;
};

export enum ChallengePublicationStatus {
  ALL = 'ALL',
  ARCHIVED = 'ARCHIVED',
  PUBLISHED = 'PUBLISHED',
  UNPUBLISHED = 'UNPUBLISHED'
}

export type ChallengeQuestion = {
  __typename?: 'ChallengeQuestion';
  challengeId?: Maybe<Scalars['ID']>;
  characterLimit?: Maybe<Scalars['Int']>;
  communityId?: Maybe<Scalars['ID']>;
  description?: Maybe<Scalars['String']>;
  hidden?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  inCreation?: Maybe<Scalars['Boolean']>;
  inPhase?: Maybe<Scalars['Boolean']>;
  milestoneId?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  options?: Maybe<Array<ChallengeQuestionOption>>;
  order?: Maybe<Scalars['Int']>;
  phaseList?: Maybe<Scalars['String']>;
  required?: Maybe<Scalars['Boolean']>;
  settings?: Maybe<Scalars['String']>;
  translations?: Maybe<Array<Translation>>;
  type: Scalars['String'];
};

export type ChallengeQuestionInput = {
  characterLimit?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  hidden: Scalars['Boolean'];
  id: Scalars['String'];
  inPhase: Scalars['Boolean'];
  milestoneId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  options?: Maybe<Array<ChallengeQuestionOptionInput>>;
  order: Scalars['Int'];
  required: Scalars['Boolean'];
  translations?: Maybe<Array<TranslationInput>>;
  type: Scalars['String'];
};

export type ChallengeQuestionOption = {
  __typename?: 'ChallengeQuestionOption';
  challengeQuestionId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  text?: Maybe<Scalars['String']>;
  translations?: Maybe<Array<Translation>>;
};

export type ChallengeQuestionOptionInput = {
  challengeQuestionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  translations?: Maybe<Array<TranslationInput>>;
};

export type ChallengeSorting = {
  __typename?: 'ChallengeSorting';
  default: Scalars['String'];
  options: Array<Scalars['String']>;
};

export type ChallengeSortingInput = {
  default: Scalars['String'];
  options: Array<Scalars['String']>;
};

export type ChallengeStats = {
  __typename?: 'ChallengeStats';
  comments?: Maybe<Scalars['Int']>;
  commentsPlusChildren?: Maybe<Scalars['Int']>;
  ideas?: Maybe<Scalars['Int']>;
  ideasPlusChildren?: Maybe<Scalars['Int']>;
  subscribers?: Maybe<Scalars['Int']>;
  users?: Maybe<Scalars['Int']>;
  usersPlusChildren?: Maybe<Scalars['Int']>;
  votes?: Maybe<Scalars['Int']>;
  votesPlusChildren?: Maybe<Scalars['Int']>;
};

export type ChallengeTemplateInput = {
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type ChallengeVisibility = {
  __typename?: 'ChallengeVisibility';
  comments: AccessComments;
  copyUrlEnabled?: Maybe<Scalars['Boolean']>;
  ideaEditLock: IdeaEditLock;
  ideaSubmissionEnabled: Scalars['Boolean'];
  ideasVisible: Scalars['Boolean'];
  jointSubmissionEnabled: Scalars['Boolean'];
  phaseAutoAdvancement?: Maybe<Scalars['Boolean']>;
  phaseResetComments?: Maybe<Scalars['Boolean']>;
  phaseResetVotes?: Maybe<Scalars['Boolean']>;
  privateSubmissionEnabled: Scalars['Boolean'];
  shareFacebookEnabled?: Maybe<Scalars['Boolean']>;
  shareLinkedInEnabled?: Maybe<Scalars['Boolean']>;
  shareTwitterEnabled?: Maybe<Scalars['Boolean']>;
  showClosedEnabled: Scalars['Boolean'];
  voteOnCommentsEnabled: Scalars['Boolean'];
  voteOnIdeasEnabled: Scalars['Boolean'];
};

export type ChallengeVisibilityInput = {
  comments: AccessCommentsInput;
  copyUrlEnabled?: Maybe<Scalars['Boolean']>;
  ideaEditLock: IdeaEditLockInput;
  ideaSubmissionEnabled: Scalars['Boolean'];
  ideasVisible: Scalars['Boolean'];
  jointSubmissionEnabled: Scalars['Boolean'];
  phaseAutoAdvancement?: Maybe<Scalars['Boolean']>;
  phaseResetComments?: Maybe<Scalars['Boolean']>;
  phaseResetVotes?: Maybe<Scalars['Boolean']>;
  privateSubmissionEnabled: Scalars['Boolean'];
  shareFacebookEnabled?: Maybe<Scalars['Boolean']>;
  shareLinkedInEnabled?: Maybe<Scalars['Boolean']>;
  shareTwitterEnabled?: Maybe<Scalars['Boolean']>;
  showClosedEnabled: Scalars['Boolean'];
  voteOnCommentsEnabled: Scalars['Boolean'];
  voteOnIdeasEnabled: Scalars['Boolean'];
};

export type ColumnSortType = {
  column: Scalars['String'];
  direction?: Maybe<Scalars['String']>;
};

export type Comment = {
  __typename?: 'Comment';
  adoptionStatus?: Maybe<Scalars['Int']>;
  challengeId: Scalars['Int'];
  communityId: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currentMilestone?: Maybe<Scalars['ID']>;
  hasReports: Scalars['Int'];
  id: Scalars['ID'];
  isModeratorComment?: Maybe<Scalars['Int']>;
  moderationStatus?: Maybe<Scalars['Int']>;
  parentId: Scalars['ID'];
  topParentId: Scalars['ID'];
  type?: Maybe<Scalars['Int']>;
  userId: Scalars['Int'];
};

export type Community = {
  __typename?: 'Community';
  apiEnabled: Scalars['Boolean'];
  closed?: Maybe<Scalars['Boolean']>;
  colors?: Maybe<CommunityDesign>;
  countries?: Maybe<Array<Scalars['String']>>;
  defaultAccess?: Maybe<DefaultAccess>;
  hideUnModerated: Scalars['Int'];
  id: Scalars['ID'];
  logoFile?: Maybe<File>;
  logoId?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  options?: Maybe<CommunityOptions>;
  url: Scalars['String'];
  userFields?: Maybe<Array<UserField>>;
};

export type CommunityDesign = {
  __typename?: 'CommunityDesign';
  backgroundIsAttached?: Maybe<Scalars['Boolean']>;
  backgroundIsRepeated?: Maybe<Scalars['Boolean']>;
  backgroundPosition?: Maybe<Scalars['String']>;
  banner?: Maybe<Scalars['String']>;
  bannerHeight?: Maybe<Scalars['Int']>;
  bg?: Maybe<Scalars['String']>;
  button?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  voteBar?: Maybe<Scalars['String']>;
};

export type CommunityLanguage = {
  __typename?: 'CommunityLanguage';
  iso: Scalars['String'];
  name: Scalars['String'];
};

export type CommunityOptions = {
  __typename?: 'CommunityOptions';
  allowAzureLogin?: Maybe<Scalars['Boolean']>;
  allowCrowdicityLogin?: Maybe<Scalars['Boolean']>;
  allowedLanguages?: Maybe<Array<CommunityLanguage>>;
  allowLanguageChoice?: Maybe<Scalars['Boolean']>;
  allowMessaging?: Maybe<Scalars['Boolean']>;
  allowPushNotifications?: Maybe<Scalars['Boolean']>;
  allowSAML2Login?: Maybe<Scalars['Boolean']>;
  allowSocialMediaLinksInProfile?: Maybe<Scalars['Boolean']>;
  allowSocialMediaLogin?: Maybe<Scalars['Boolean']>;
  apiEnabled?: Maybe<Scalars['Boolean']>;
  crowdicityAsIDPForSalesforce?: Maybe<Scalars['Boolean']>;
  enableSlackIntegration?: Maybe<Scalars['Boolean']>;
  enableTeamsIntegration?: Maybe<Scalars['Boolean']>;
  facebookAllowFollow?: Maybe<Scalars['Boolean']>;
  facebookName?: Maybe<Scalars['String']>;
  insightsSuite?: Maybe<InsightsSuite>;
  OpenIdProvider?: Maybe<Scalars['String']>;
  showUserScores?: Maybe<Scalars['Boolean']>;
  translationLanguages?: Maybe<Array<Scalars['String']>>;
  twitterAllowFollow?: Maybe<Scalars['Boolean']>;
  twitterName?: Maybe<Scalars['String']>;
  youtubeAllowFollow?: Maybe<Scalars['Boolean']>;
  youtubeName?: Maybe<Scalars['String']>;
};

export type CreateChallengeInput = {
  archived?: Maybe<Scalars['Float']>;
  isGlobal?: Maybe<Scalars['Boolean']>;
  templateId?: Maybe<Scalars['String']>;
};

export type DataLog = {
  __typename?: 'DataLog';
  changeType?: Maybe<Scalars['String']>;
  communityId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  newData?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  objectId?: Maybe<Scalars['Int']>;
  objectType?: Maybe<Scalars['String']>;
  oldData?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Int']>;
};


export type DefaultAccess = {
  __typename?: 'DefaultAccess';
  groups: Array<UserGroupWithModerationStatus>;
  users: Array<UserWithModerationStatus>;
};

export type Error = {
  __typename?: 'Error';
  communityId?: Maybe<Scalars['Int']>;
  context?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  file?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  level?: Maybe<Scalars['Int']>;
  line?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Int']>;
};

export type File = {
  __typename?: 'File';
  avatarReady?: Maybe<Scalars['Int']>;
  badgeReady?: Maybe<Scalars['Int']>;
  challengeReady?: Maybe<Scalars['Int']>;
  checksum?: Maybe<Scalars['String']>;
  cloudDate?: Maybe<Scalars['DateTime']>;
  cloudinaryDate?: Maybe<Scalars['DateTime']>;
  cloudinaryEncoded?: Maybe<Scalars['Int']>;
  communityId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extension: Scalars['String'];
  hash: Scalars['String'];
  id: Scalars['ID'];
  logoReady?: Maybe<Scalars['Int']>;
  mimeType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  origin?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['String']>;
  thumbnailCreated?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
  virusScanStatus?: Maybe<Scalars['Int']>;
};

export type FileInput = {
  extension?: Maybe<Scalars['String']>;
  hash: Scalars['String'];
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type FileLink = {
  __typename?: 'FileLink';
  fileId: Scalars['ID'];
  id: Scalars['ID'];
  itemId: Scalars['ID'];
  itemType?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
};

export type FollowChallengeInput = {
  include?: Maybe<ChallengeFollowIncludeType>;
  lastUpdate?: Maybe<Scalars['DateTime']>;
  specific?: Maybe<Scalars['String']>;
  type?: Maybe<ChallengeFollowType>;
};

export enum FollowType {
  CHALLENGE = 'CHALLENGE',
  IDEA = 'IDEA',
  USER = 'USER'
}

export type GlobalCategory = {
  __typename?: 'GlobalCategory';
  accessMode?: Maybe<Scalars['String']>;
  communityId: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
  order: Scalars['Int'];
  status?: Maybe<Scalars['Int']>;
};

export type GlobalCategoryWithAssignedField = {
  __typename?: 'GlobalCategoryWithAssignedField';
  assigned: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  order: Scalars['Int'];
};

export type GlobalCategoryWithAssignedFieldInput = {
  assigned: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  order: Scalars['Int'];
};

export type GlobalTemplate = {
  __typename?: 'GlobalTemplate';
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  template: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type Idea = {
  __typename?: 'Idea';
  adoptionStatus?: Maybe<Scalars['Int']>;
  challenge?: Maybe<Challenge>;
  challengeId: Scalars['ID'];
  commentCount?: Maybe<Scalars['Int']>;
  communityId: Scalars['ID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currentMilestone?: Maybe<Scalars['ID']>;
  currentPhase?: Maybe<Scalars['ID']>;
  endPhase?: Maybe<Scalars['ID']>;
  files?: Maybe<IdeaFiles>;
  hasReports?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  lastReachedMilestone?: Maybe<Scalars['ID']>;
  moderationStatus?: Maybe<Scalars['Int']>;
  parentId?: Maybe<Scalars['ID']>;
  score?: Maybe<Scalars['Float']>;
  startPhase?: Maybe<Scalars['ID']>;
  stats?: Maybe<IdeaStats>;
  text?: Maybe<Scalars['String']>;
  theme?: Maybe<Theme>;
  title?: Maybe<Scalars['String']>;
  topParentId?: Maybe<Scalars['ID']>;
  user?: Maybe<User>;
  userId: Scalars['ID'];
  views?: Maybe<Scalars['Int']>;
  voteCount?: Maybe<Scalars['Int']>;
};

export type IdeaEditLock = {
  __typename?: 'IdeaEditLock';
  enabled: Scalars['Boolean'];
  graceMinutes?: Maybe<Scalars['Int']>;
};

export type IdeaEditLockInput = {
  enabled: Scalars['Boolean'];
  graceMinutes?: Maybe<Scalars['Int']>;
};

export type IdeaFiles = {
  __typename?: 'IdeaFiles';
  images?: Maybe<Array<File>>;
};

export type IdeaFollow = {
  __typename?: 'IdeaFollow';
  id: Scalars['ID'];
  ideaId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type IdeaStats = {
  __typename?: 'IdeaStats';
  comments: Scalars['Int'];
  followers: Scalars['Int'];
  views?: Maybe<Scalars['Int']>;
  votes?: Maybe<Scalars['Int']>;
};

export type IdeaStatus = {
  __typename?: 'IdeaStatus';
  color: Scalars['String'];
  communityId: Scalars['Int'];
  defaultNameOverride?: Maybe<Scalars['Int']>;
  enabled?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
  textColor: Scalars['String'];
};

export type IdeaStatusLink = {
  __typename?: 'IdeaStatusLink';
  date?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  ideaId?: Maybe<Scalars['Int']>;
  ideaStatusId?: Maybe<Scalars['Int']>;
};

export type IdeaStatusesResultType = {
  __typename?: 'IdeaStatusesResultType';
  ideaCount: Scalars['Int'];
  statusId: Scalars['Int'];
  statusName: Scalars['String'];
};

export type IdeaTagsResultType = {
  __typename?: 'IdeaTagsResultType';
  ideaCount: Scalars['Int'];
  tagId: Scalars['Int'];
  tagName: Scalars['String'];
};

export type IdeasAndCount = {
  __typename?: 'IdeasAndCount';
  count: Scalars['Float'];
  rows: Array<Idea>;
};

export type InsightsSuite = {
  __typename?: 'InsightsSuite';
  enabled: Scalars['Boolean'];
};

export type Language = {
  __typename?: 'Language';
  language: Scalars['String'];
};

export type Milestone = {
  __typename?: 'Milestone';
  access: MilestoneOption;
  allowComments?: Maybe<Scalars['Boolean']>;
  approachEmailMessageToModerators?: Maybe<Scalars['String']>;
  approachEmailMessageToVoters?: Maybe<Scalars['String']>;
  approachMessageToAuthors?: Maybe<Scalars['String']>;
  approachMessageToUsers?: Maybe<Scalars['String']>;
  challengeId?: Maybe<Scalars['ID']>;
  condition: MilestoneCondition;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  ideas?: Maybe<Array<Idea>>;
  ideasHaveVotes?: Maybe<Scalars['Boolean']>;
  isPrivateSubmission?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  minimumVotes?: Maybe<Scalars['Int']>;
  moderators?: Maybe<UsersAndGroups>;
  name?: Maybe<Scalars['String']>;
  notifyVoters?: Maybe<Scalars['Int']>;
  questions?: Maybe<Array<ChallengeQuestion>>;
  reachedEmailMessageToAuthors?: Maybe<Scalars['String']>;
  resetComments?: Maybe<Scalars['Int']>;
  resetVotes?: Maybe<Scalars['Boolean']>;
  scorecards?: Maybe<Array<Scorecard>>;
  showUsers?: Maybe<Scalars['Int']>;
  target?: Maybe<Scalars['Int']>;
  translations?: Maybe<Array<Translation>>;
  type: MilestoneType;
  voters?: Maybe<UsersAndGroups>;
  voting?: Maybe<Voting>;
};


export type MilestoneIdeasArgs = {
  filters?: Maybe<UserSearchFilters>;
};

export type MilestoneCondition = {
  __typename?: 'MilestoneCondition';
  id: Scalars['ID'];
  milestoneId?: Maybe<Scalars['ID']>;
  target?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export type MilestoneInput = {
  completeMessageToAuthors?: Maybe<Scalars['String']>;
  completeMessageToUsers?: Maybe<Scalars['String']>;
  milestoneRejectedIdeaIds?: Maybe<Array<Scalars['String']>>;
  milestones?: Maybe<Array<MilestonesInput>>;
};

export type MilestoneModerator = {
  __typename?: 'MilestoneModerator';
  id: Scalars['ID'];
  milestoneId: Scalars['ID'];
  moderatorId: Scalars['ID'];
  type?: Maybe<Scalars['String']>;
};

export type MilestoneModeratorInput = {
  groups?: Maybe<Array<ModeratorInput>>;
  users?: Maybe<Array<ModeratorInput>>;
};

export type MilestoneOption = {
  __typename?: 'MilestoneOption';
  allowComments: Scalars['Boolean'];
  privateSubmissionEnabled: Scalars['Boolean'];
};

export enum MilestoneType {
  APPROVAL = 'APPROVAL',
  REFINE = 'REFINE',
  SUBMITTED = 'SUBMITTED',
  VOTE = 'VOTE'
}

export type MilestoneVoter = {
  __typename?: 'MilestoneVoter';
  id: Scalars['ID'];
  milestoneId: Scalars['ID'];
  type?: Maybe<Scalars['String']>;
  voterId: Scalars['ID'];
};

export type MilestoneVoterInput = {
  groups?: Maybe<Array<VoterInput>>;
  users?: Maybe<Array<VoterInput>>;
};

export type MilestonesInput = {
  allowComments: Scalars['Boolean'];
  approachEmailMessageToModerators?: Maybe<Scalars['String']>;
  approachEmailMessageToVoters?: Maybe<Scalars['String']>;
  approachMessageToAuthors?: Maybe<Scalars['String']>;
  approachMessageToUsers?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  id: Scalars['String'];
  isPrivateSubmission: Scalars['Boolean'];
  label: Scalars['String'];
  minimumVotes?: Maybe<Scalars['Int']>;
  moderators?: Maybe<MilestoneModeratorInput>;
  name: Scalars['String'];
  notifyVoters?: Maybe<Scalars['Boolean']>;
  questions?: Maybe<Array<ChallengeQuestionInput>>;
  reachedEmailMessageToAuthors?: Maybe<Scalars['String']>;
  resetVotes?: Maybe<Scalars['Boolean']>;
  target?: Maybe<Scalars['Int']>;
  translations?: Maybe<Array<TranslationInput>>;
  type?: Maybe<Scalars['String']>;
  voters?: Maybe<MilestoneVoterInput>;
  voting?: Maybe<VotingInput>;
};

export type ModeratorActionBackupTranslation = {
  __typename?: 'ModeratorActionBackupTranslation';
  id: Scalars['ID'];
  language: Scalars['String'];
  objectId: Scalars['Int'];
  objectType: Scalars['String'];
  text: Scalars['String'];
};

export type ModeratorActionBaseEntity = {
  __typename?: 'ModeratorActionBaseEntity';
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

export type ModeratorActionIdeaMovePayload = {
  __typename?: 'ModeratorActionIdeaMovePayload';
  from: ModeratorActionLinkedEntity;
  to: ModeratorActionLinkedEntity;
};

export type ModeratorActionIdeaStatusPayload = {
  __typename?: 'ModeratorActionIdeaStatusPayload';
  added: Array<ModeratorActionBaseEntity>;
  removed: Array<ModeratorActionBaseEntity>;
};

export type ModeratorActionLinkedEntity = {
  __typename?: 'ModeratorActionLinkedEntity';
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type ModeratorActionLog = {
  __typename?: 'ModeratorActionLog';
  communityId: Scalars['ID'];
  created: Scalars['DateTime'];
  id: Scalars['ID'];
  moderatorActionId: Scalars['ID'];
  objectData?: Maybe<Scalars['String']>;
  objectId?: Maybe<Scalars['ID']>;
  objectTargetId?: Maybe<Scalars['ID']>;
  postId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type ModeratorActionPayload = ModeratorActionIdeaMovePayload | ModeratorActionIdeaStatusPayload | ModeratorActionSimplePayload;

export type ModeratorActionResult = {
  __typename?: 'ModeratorActionResult';
  items: Array<ModeratorActionResultItem>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  total: Scalars['Int'];
};

export type ModeratorActionResultItem = {
  __typename?: 'ModeratorActionResultItem';
  actionId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  payload: ModeratorActionPayload;
  user: ModeratorActionUserEntity;
};

export type ModeratorActionSimplePayload = {
  __typename?: 'ModeratorActionSimplePayload';
  id: Scalars['Int'];
  name: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type ModeratorActionUserEntity = {
  __typename?: 'ModeratorActionUserEntity';
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type ModeratorInput = {
  id?: Maybe<Scalars['String']>;
  milestoneId: Scalars['String'];
  moderatorId: Scalars['String'];
  type: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  cloneChallenge: Challenge;
  createChallenge: Challenge;
  deleteTemplate: Scalars['Boolean'];
  deleteUserAccount?: Maybe<SuccessMessageResponseType>;
  follow: SuccessMessageResponseType;
  followUser: SuccessMessageResponseType;
  notifications: Array<NotificationEvent>;
  saveApiClient?: Maybe<ApiClient>;
  saveApiRequest?: Maybe<ApiRequest>;
  saveSocialMedia?: Maybe<User>;
  unfollow: SuccessMessageResponseType;
  unfollowUser: SuccessMessageResponseType;
  updateChallenge: Challenge;
  updateSettings: UserSettingsResponseType;
  updateStealth: SuccessMessageResponseType;
  users?: Maybe<UserSearchResult>;
};


export type MutationCloneChallengeArgs = {
  id: Scalars['ID'];
};


export type MutationCreateChallengeArgs = {
  input: CreateChallengeInput;
};


export type MutationDeleteTemplateArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUserAccountArgs = {
  id: Scalars['String'];
};


export type MutationFollowArgs = {
  input: NotificationFollowInput;
};


export type MutationFollowUserArgs = {
  targetUser: Scalars['String'];
};


export type MutationNotificationsArgs = {
  categories?: Maybe<Array<NotificationCategory>>;
  from?: Maybe<Scalars['String']>;
};


export type MutationSaveApiClientArgs = {
  input: ApiClientInput;
};


export type MutationSaveApiRequestArgs = {
  input: ApiRequestInput;
};


export type MutationSaveSocialMediaArgs = {
  input: Array<SocialLinkInput>;
};


export type MutationUnfollowArgs = {
  input: NotificationFollowInput;
};


export type MutationUnfollowUserArgs = {
  targetUser: Scalars['String'];
};


export type MutationUpdateChallengeArgs = {
  input: ChallengeInput;
};


export type MutationUpdateSettingsArgs = {
  input: Array<UserNotificationSettingsInput>;
};


export type MutationUpdateStealthArgs = {
  enabled: Scalars['Boolean'];
};


export type MutationUsersArgs = {
  filters?: Maybe<UserSearchFilters>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export type Notification = {
  __typename?: 'Notification';
  challengeId: Scalars['ID'];
  commentId: Scalars['ID'];
  date: Scalars['DateTime'];
  id: Scalars['ID'];
  ideaId: Scalars['ID'];
};

export enum NotificationActions {
  REPLY = 'REPLY',
  VIEW = 'VIEW'
}

export enum NotificationCategory {
  BLOG_ACTIVITY = 'BLOG_ACTIVITY',
  COMMENT_ACTIVITY = 'COMMENT_ACTIVITY',
  FOLLOWED_USER_ACTIVITY = 'FOLLOWED_USER_ACTIVITY',
  IDEA_ACTIVITY = 'IDEA_ACTIVITY',
  NEW_CHALLENGES_AND_IDEAS = 'NEW_CHALLENGES_AND_IDEAS'
}

export type NotificationEvent = {
  __typename?: 'NotificationEvent';
  actions: Array<NotificationActions>;
  blogPost?: Maybe<BlogPost>;
  blogPostId?: Maybe<Scalars['String']>;
  body: Scalars['String'];
  category?: Maybe<NotificationCategory>;
  challenge?: Maybe<Challenge>;
  challengeId?: Maybe<Scalars['String']>;
  commentId?: Maybe<Scalars['String']>;
  created: Scalars['DateTime'];
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  idea?: Maybe<Idea>;
  ideaId?: Maybe<Scalars['String']>;
  isValid: Scalars['Boolean'];
  phaseId?: Maybe<Scalars['String']>;
  reasonId: Scalars['String'];
  reasonType: NotificationReasonType;
  subject: Scalars['String'];
  type: NotificationType;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
};

export type NotificationFollowInput = {
  challenge?: Maybe<FollowChallengeInput>;
  targetId: Scalars['String'];
  type: FollowType;
};

export enum NotificationReasonType {
  CHALLENGE_MODERATOR = 'CHALLENGE_MODERATOR',
  COMMUNITY = 'COMMUNITY',
  FOLLOWED_BLOG = 'FOLLOWED_BLOG',
  FOLLOWED_BLOG_POST = 'FOLLOWED_BLOG_POST',
  FOLLOWED_CHALLENGE = 'FOLLOWED_CHALLENGE',
  FOLLOWED_IDEA = 'FOLLOWED_IDEA',
  FOLLOWED_USER = 'FOLLOWED_USER',
  USER_TAGGED_IN_COMMENT = 'USER_TAGGED_IN_COMMENT',
  USER_TAGGED_IN_IDEA = 'USER_TAGGED_IN_IDEA',
  USER_WITH_CHALLENGE_ACCESS = 'USER_WITH_CHALLENGE_ACCESS'
}

export type NotificationSettings = {
  __typename?: 'NotificationSettings';
  slackforpostcomment?: Maybe<Scalars['Boolean']>;
  slackforpostfollow?: Maybe<Scalars['Boolean']>;
  slackforpostvote?: Maybe<Scalars['Boolean']>;
  teamsConversationId?: Maybe<Scalars['String']>;
  teamsforpostcomment?: Maybe<Scalars['Boolean']>;
  teamsforpostfollow?: Maybe<Scalars['Boolean']>;
  teamsforpostvote?: Maybe<Scalars['Boolean']>;
};

export enum NotificationSettingsEventAction {
  AWARD = 'AWARD',
  COMMENT = 'COMMENT',
  FOLLOW = 'FOLLOW',
  MOVE = 'MOVE',
  NEW = 'NEW',
  REJECT = 'REJECT',
  REMOVE = 'REMOVE',
  REPLY = 'REPLY',
  TAG = 'TAG',
  VOTE = 'VOTE'
}

export enum NotificationSettingsEventSubject {
  CHALLENGE = 'CHALLENGE',
  COMMENT = 'COMMENT',
  IDEA = 'IDEA',
  MESSAGE = 'MESSAGE',
  USER = 'USER'
}

export enum NotificationSettingsFrequency {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY'
}

export enum NotificationSettingsTransport {
  EMAIL = 'EMAIL',
  PUSH = 'PUSH',
  SLACK = 'SLACK',
  STREAM = 'STREAM'
}

export enum NotificationType {
  BLOG_POST_COMMENT = 'BLOG_POST_COMMENT',
  BLOG_POST_NEW = 'BLOG_POST_NEW',
  CHALLENGE_CHECK_OUT = 'CHALLENGE_CHECK_OUT',
  CHALLENGE_ENTERED_PHASE = 'CHALLENGE_ENTERED_PHASE',
  CHALLENGE_NEW = 'CHALLENGE_NEW',
  COMMENT_NEW = 'COMMENT_NEW',
  COMMENT_REPLY = 'COMMENT_REPLY',
  IDEA_CHECK_OUT = 'IDEA_CHECK_OUT',
  IDEA_COMMENT = 'IDEA_COMMENT',
  IDEA_FOLLOW = 'IDEA_FOLLOW',
  IDEA_MILESTONE_REACHED = 'IDEA_MILESTONE_REACHED',
  IDEA_NEW = 'IDEA_NEW',
  IDEA_PHASE_REACHED = 'IDEA_PHASE_REACHED',
  IDEA_TAG = 'IDEA_TAG',
  IDEA_VOTE = 'IDEA_VOTE'
}

export type Phase = {
  __typename?: 'Phase';
  access: AccessOption;
  challenge?: Maybe<Challenge>;
  challengeId?: Maybe<Scalars['ID']>;
  commentMode?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  ideas?: Maybe<Array<Idea>>;
  isPrivateSubmission?: Maybe<Scalars['Boolean']>;
  moderatorRights?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  participantRights?: Maybe<Scalars['String']>;
  questions?: Maybe<Array<ChallengeQuestion>>;
  scorecards?: Maybe<Array<Scorecard>>;
  startDate?: Maybe<Scalars['DateTime']>;
  stats?: Maybe<Scalars['String']>;
  translations?: Maybe<Array<Translation>>;
  visible?: Maybe<Scalars['Int']>;
  voteMode?: Maybe<Scalars['Int']>;
  voting: Voting;
};


export type PhaseIdeasArgs = {
  filters?: Maybe<UserSearchFilters>;
};

export type PhaseInput = {
  access: AccessOptionInput;
  description: Scalars['String'];
  endDate: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  questions?: Maybe<Array<ChallengeQuestionInput>>;
  startDate: Scalars['String'];
  translations?: Maybe<Array<TranslationInput>>;
  voting?: Maybe<VotingInput>;
};

export type PushnotificationPreferences = {
  __typename?: 'PushnotificationPreferences';
  communityId: Scalars['ID'];
  deviceTokens: Scalars['String'];
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  userId: Scalars['ID'];
};

export type Query = {
  __typename?: 'Query';
  accessibleChallenges?: Maybe<Array<Challenge>>;
  apiRequests?: Maybe<Array<ApiRequest>>;
  badge: Badge;
  blogPost: BlogPost;
  blogPosts: Array<BlogPost>;
  challenge?: Maybe<Challenge>;
  challengeExist: Scalars['Boolean'];
  challenges?: Maybe<Array<Challenge>>;
  checkFollowing: SuccessMessageResponseType;
  coauthorIdeas: Array<Scalars['Int']>;
  community?: Maybe<Community>;
  dailySummary?: Maybe<Array<StatResultType>>;
  filteredUsers: Array<Scalars['Int']>;
  getScorecards: Array<Challenge>;
  globalTemplates?: Maybe<Array<GlobalTemplate>>;
  idea: Idea;
  ideasAndCount: IdeasAndCount;
  ideaStatusesSummary?: Maybe<Array<IdeaStatusesResultType>>;
  ideaTagsSummary?: Maybe<Array<IdeaTagsResultType>>;
  me?: Maybe<User>;
  moderatorActionLogs?: Maybe<ModeratorActionResult>;
  notifications: Array<NotificationEvent>;
  phase?: Maybe<Phase>;
  searchUsergroups: Array<UserGroup>;
  searchUsers: Array<User>;
  serializeChallengeToTemplate: Template;
  socialMedia?: Maybe<Array<SocialMedia>>;
  stat?: Maybe<Stat>;
  stats?: Maybe<Array<StatResultType>>;
  statusIdeasAndCount?: Maybe<IdeasAndCount>;
  tagIdeasAndCount?: Maybe<IdeasAndCount>;
  template?: Maybe<Template>;
  templates?: Maybe<Templates>;
  theme: Theme;
  themeIdeasAndCount: IdeasAndCount;
  themeIdeasSummary?: Maybe<Array<ThemeIdeasResultType>>;
  themes: Array<Theme>;
  user?: Maybe<User>;
  userFields: Array<UserField>;
  userLoginStats?: Maybe<Array<StatResultType>>;
  userNotificationSettings: Array<UserNotificationSettings>;
  userRankings?: Maybe<Array<UserRanking>>;
  users?: Maybe<UserSearchResult>;
  votesAndCommentsCount: VoteAndCommentResultType;
};


export type QueryAccessibleChallengesArgs = {
  publicationStatus?: Maybe<ChallengePublicationStatus>;
};


export type QueryBadgeArgs = {
  id: Scalars['String'];
};


export type QueryBlogPostArgs = {
  id: Scalars['Int'];
};


export type QueryBlogPostsArgs = {
  limit?: Maybe<Scalars['Int']>;
};


export type QueryChallengeArgs = {
  id: Scalars['String'];
};


export type QueryChallengeExistArgs = {
  id: Scalars['String'];
  title: Scalars['String'];
};


export type QueryChallengesArgs = {
  order?: Maybe<Array<Scalars['String']>>;
  publicationStatus?: Maybe<ChallengePublicationStatus>;
  types?: Maybe<Array<Scalars['String']>>;
};


export type QueryCheckFollowingArgs = {
  targetUser: Scalars['String'];
  userId: Scalars['String'];
};


export type QueryCoauthorIdeasArgs = {
  customFiltersUserIds: Array<Scalars['Int']>;
  filters: UserSearchFilters;
};


export type QueryCommunityArgs = {
  id: Scalars['String'];
};


export type QueryDailySummaryArgs = {
  challengeSelection?: Maybe<Scalars['String']>;
  filters?: Maybe<UserSearchFilters>;
  startDate?: Maybe<Scalars['String']>;
};


export type QueryFilteredUsersArgs = {
  filters: UserSearchFilters;
};


export type QueryGetScorecardsArgs = {
  id: Scalars['String'];
};


export type QueryIdeaArgs = {
  id: Scalars['Int'];
};


export type QueryIdeasAndCountArgs = {
  challengeSelection?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  filters?: Maybe<UserSearchFilters>;
  limit?: Maybe<Scalars['Int']>;
  milestoneSelection?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order?: Maybe<Array<Array<Scalars['String']>>>;
  phaseSelection?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['String']>;
};


export type QueryIdeaStatusesSummaryArgs = {
  challengeSelection?: Maybe<Scalars['String']>;
  filters?: Maybe<UserSearchFilters>;
};


export type QueryIdeaTagsSummaryArgs = {
  challengeSelection?: Maybe<Scalars['String']>;
  filters?: Maybe<UserSearchFilters>;
};


export type QueryModeratorActionLogsArgs = {
  ideaId: Scalars['Int'];
  language?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryNotificationsArgs = {
  categories?: Maybe<Array<NotificationCategory>>;
  from?: Maybe<Scalars['String']>;
};


export type QueryPhaseArgs = {
  id: Scalars['String'];
};


export type QuerySearchUsergroupsArgs = {
  searchText: Scalars['String'];
  types: Array<UserGroupType>;
};


export type QuerySearchUsersArgs = {
  searchText: Scalars['String'];
};


export type QuerySerializeChallengeToTemplateArgs = {
  id: Scalars['String'];
};


export type QueryStatArgs = {
  id: Scalars['String'];
};


export type QueryStatsArgs = {
  endDate: Scalars['String'];
  filters?: Maybe<UserSearchFilters>;
  startDate: Scalars['String'];
  type: Array<Scalars['Int']>;
};


export type QueryStatusIdeasAndCountArgs = {
  challengeSelection: Scalars['String'];
  filters?: Maybe<UserSearchFilters>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order?: Maybe<Array<Array<Scalars['String']>>>;
  statusSelection: Scalars['String'];
};


export type QueryTagIdeasAndCountArgs = {
  challengeSelection: Scalars['String'];
  filters?: Maybe<UserSearchFilters>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order?: Maybe<Array<Array<Scalars['String']>>>;
  tagSelection: Scalars['String'];
};


export type QueryTemplateArgs = {
  id: Scalars['Float'];
};


export type QueryThemeArgs = {
  id: Scalars['Float'];
};


export type QueryThemeIdeasAndCountArgs = {
  challengeSelection?: Maybe<Scalars['String']>;
  filters?: Maybe<UserSearchFilters>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order?: Maybe<Array<Array<Scalars['String']>>>;
  themeSelection?: Maybe<Scalars['String']>;
};


export type QueryThemeIdeasSummaryArgs = {
  challengeSelection?: Maybe<Scalars['String']>;
  filters?: Maybe<UserSearchFilters>;
  themeSelection?: Maybe<Scalars['String']>;
};


export type QueryUserArgs = {
  id: Scalars['String'];
};


export type QueryUserLoginStatsArgs = {
  endDate: Scalars['String'];
  filters?: Maybe<UserSearchFilters>;
  startDate: Scalars['String'];
};


export type QueryUserRankingsArgs = {
  challengeId?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryUsersArgs = {
  filters?: Maybe<UserSearchFilters>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryVotesAndCommentsCountArgs = {
  filters?: Maybe<UserSearchFilters>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order?: Maybe<ColumnSortType>;
  publicationStatus?: Maybe<ChallengePublicationStatus>;
};

export type Scorecard = {
  __typename?: 'Scorecard';
  challengeId?: Maybe<Scalars['ID']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  milestoneId?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  phaseId?: Maybe<Scalars['ID']>;
  translations?: Maybe<Array<Translation>>;
};

export type ScorecardInput = {
  challengeId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  milestoneId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  phaseId?: Maybe<Scalars['String']>;
  translations?: Maybe<Array<TranslationInput>>;
};

export type ScorecardLabel = {
  __typename?: 'ScorecardLabel';
  challengeId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  milestoneId?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['String']>;
  translations?: Maybe<Array<Translation>>;
};

export type ScorecardLabelInput = {
  challengeId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  milestoneId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  rating: Scalars['String'];
  translations?: Maybe<Array<TranslationInput>>;
};

export type ScorecardsAndLabels = {
  __typename?: 'ScorecardsAndLabels';
  cards?: Maybe<Array<Scorecard>>;
  labels?: Maybe<Array<ScorecardLabel>>;
};

export type ScorecardsAndLabelsInput = {
  cards?: Maybe<Array<ScorecardInput>>;
  labels?: Maybe<Array<ScorecardLabelInput>>;
};

export type SocialLinkInput = {
  id: Scalars['String'];
  type: Scalars['String'];
  url: Scalars['String'];
};

export type SocialLinkType = {
  __typename?: 'SocialLinkType';
  id: Scalars['String'];
  type: SocialMediaType;
  url: Scalars['String'];
};

export type SocialMedia = {
  __typename?: 'SocialMedia';
  id: Scalars['ID'];
  image: Scalars['String'];
  name: Scalars['String'];
  type: SocialMediaType;
};

export enum SocialMediaType {
  Facebook = 'Facebook',
  Google = 'Google',
  Instagram = 'Instagram',
  LinkedIn = 'LinkedIn',
  Twitter = 'Twitter',
  Unknown = 'Unknown'
}

export type Stat = {
  __typename?: 'Stat';
  date?: Maybe<Scalars['String']>;
  hubbub?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  sourceId?: Maybe<Scalars['String']>;
  type: StatType;
  url?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['String']>;
  value1?: Maybe<Scalars['String']>;
  value2?: Maybe<Scalars['String']>;
};

export type StatResultType = {
  __typename?: 'StatResultType';
  created?: Maybe<Scalars['Float']>;
  date: Scalars['String'];
  total: Scalars['Float'];
  type: Scalars['Float'];
};

export enum StatType {
  COMMENT_CREATED = 'COMMENT_CREATED',
  IDEA_CREATED = 'IDEA_CREATED',
  PAGE_VIEW = 'PAGE_VIEW',
  POST_VIEW = 'POST_VIEW',
  USER_ACTIVATION = 'USER_ACTIVATION',
  USER_JOIN = 'USER_JOIN',
  VOTE = 'VOTE'
}

export type SuccessMessageResponseType = {
  __typename?: 'SuccessMessageResponseType';
  code?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type Tag = {
  __typename?: 'Tag';
  communityId?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type TagLinkPost = {
  __typename?: 'TagLinkPost';
  id: Scalars['ID'];
  itemId: Scalars['Int'];
  itemType: Scalars['String'];
  tagId: Scalars['Int'];
  tagType: Scalars['String'];
};

export type Template = {
  __typename?: 'Template';
  communityId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  template: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userId: Scalars['ID'];
};

export type Templates = {
  __typename?: 'Templates';
  community: Array<Template>;
  global: Array<GlobalTemplate>;
};

export type Theme = {
  __typename?: 'Theme';
  archived?: Maybe<Scalars['Int']>;
  challenge?: Maybe<Challenge>;
  challengeId?: Maybe<Scalars['Int']>;
  communityId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['Int']>;
  description: Scalars['String'];
  id: Scalars['ID'];
  ideas?: Maybe<Array<Idea>>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  phaseStats?: Maybe<Scalars['String']>;
  stats?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  walletLastUpdate?: Maybe<Scalars['DateTime']>;
};

export type ThemeIdeasResultType = {
  __typename?: 'ThemeIdeasResultType';
  ideaCount: Scalars['Float'];
  themeId: Scalars['Float'];
  themeName: Scalars['String'];
};

export type ThemeInput = {
  archived: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  order: Scalars['Int'];
};

export type Translation = {
  __typename?: 'Translation';
  communityId: Scalars['ID'];
  field: Scalars['String'];
  id: Scalars['ID'];
  iso: Scalars['String'];
  objectId?: Maybe<Scalars['ID']>;
  objectType: Scalars['String'];
  value: Scalars['String'];
};

export type TranslationInput = {
  field: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  iso: Scalars['String'];
  objectId: Scalars['String'];
  objectType: Scalars['String'];
  value: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  accounts?: Maybe<Array<UserAccount>>;
  badges?: Maybe<Array<BadgeWithCountType>>;
  bio?: Maybe<Scalars['String']>;
  commentsCount?: Maybe<Scalars['Int']>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  displayName: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  emailforcommentreply?: Maybe<Scalars['Boolean']>;
  emailforcommentvote?: Maybe<Scalars['Boolean']>;
  emailforpostcomment?: Maybe<Scalars['Boolean']>;
  emailforpostfollow?: Maybe<Scalars['Boolean']>;
  emailforpostvote?: Maybe<Scalars['Boolean']>;
  emailforuserfollow?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  followers?: Maybe<Array<User>>;
  followersCount?: Maybe<Scalars['Int']>;
  following?: Maybe<Array<User>>;
  followingCount?: Maybe<Scalars['Int']>;
  hasPassword?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  ideas?: Maybe<Array<Idea>>;
  ideasCount?: Maybe<Scalars['Int']>;
  lastName?: Maybe<Scalars['String']>;
  notificationSettings?: Maybe<NotificationSettings>;
  passwordChangedAt?: Maybe<Scalars['DateTime']>;
  profileImageFile?: Maybe<File>;
  profileImageId?: Maybe<Scalars['ID']>;
  pushNotificationEnabled?: Maybe<Scalars['Boolean']>;
  ranking?: Maybe<UserRanking>;
  regCode?: Maybe<Scalars['String']>;
  screenName?: Maybe<Scalars['String']>;
  socialLinks?: Maybe<Array<SocialLinkType>>;
  subscribedChallengeIds?: Maybe<Array<Scalars['String']>>;
  subscribedIdeaIds?: Maybe<Array<Scalars['String']>>;
  timezone: Scalars['String'];
  town?: Maybe<Scalars['String']>;
  userAccess?: Maybe<UserAccess>;
  userFields?: Maybe<Array<UserFieldType>>;
  useroids?: Maybe<Array<Useroid>>;
  votesCount?: Maybe<Scalars['Int']>;
};

export type UserAccess = {
  __typename?: 'UserAccess';
  awaitingAcceptance?: Maybe<Scalars['Int']>;
  communityId: Scalars['String'];
  id: Scalars['Int'];
  instanceJoined: Scalars['DateTime'];
  language?: Maybe<Scalars['String']>;
  receiveEmails?: Maybe<Scalars['Boolean']>;
  stealthMode?: Maybe<Scalars['Boolean']>;
  userId: Scalars['Int'];
  userType: Scalars['Int'];
};

export type UserAccount = {
  __typename?: 'UserAccount';
  id: Scalars['ID'];
  provider: AccountProviderType;
  url?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
  userName: Scalars['String'];
};

export type UserBadge = {
  __typename?: 'UserBadge';
  badgeId: Scalars['ID'];
  byUser?: Maybe<Scalars['ID']>;
  communityId: Scalars['ID'];
  count?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['ID'];
};

export type UserField = {
  __typename?: 'UserField';
  communityId?: Maybe<Scalars['String']>;
  hidden?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  options?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Scalars['String']>;
};

export type UserFieldData = {
  __typename?: 'UserFieldData';
  communityId: Scalars['Float'];
  id: Scalars['ID'];
  userFieldId: Scalars['Float'];
  userId: Scalars['Int'];
  value: Scalars['String'];
};

export type UserFieldType = {
  __typename?: 'UserFieldType';
  hidden: Scalars['Boolean'];
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type UserFollow = {
  __typename?: 'UserFollow';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  targetUser: Scalars['String'];
  userId: Scalars['String'];
};

export type UserGroup = {
  __typename?: 'UserGroup';
  challengeCreator?: Maybe<Scalars['Boolean']>;
  communityId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastIndexed?: Maybe<Scalars['Int']>;
  loginChoice?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  system?: Maybe<Scalars['Int']>;
  type?: Maybe<UserGroupType>;
  userFieldId?: Maybe<Scalars['Int']>;
  userFieldOption?: Maybe<Scalars['String']>;
};

export type UserGroupAccess = {
  __typename?: 'UserGroupAccess';
  id: Scalars['Int'];
  userGroupId: Scalars['String'];
  userId: Scalars['Int'];
};

export enum UserGroupType {
  AZURE_LOGIN = 'AZURE_LOGIN',
  CROWDICITY_LOGIN = 'CROWDICITY_LOGIN',
  DYNAMIC = 'DYNAMIC',
  MEC_LOGIN = 'MEC_LOGIN',
  SAML_LOGIN = 'SAML_LOGIN',
  SOCIAL_LOGIN = 'SOCIAL_LOGIN',
  STATIC = 'STATIC'
}

export type UserGroupWithModerationStatus = {
  __typename?: 'UserGroupWithModerationStatus';
  canModerate: Scalars['Boolean'];
  usergroup: UserGroup;
};

export type UserNotificationSettings = {
  __typename?: 'UserNotificationSettings';
  enabled?: Maybe<Scalars['Boolean']>;
  eventAction?: Maybe<NotificationSettingsEventAction>;
  eventSubject?: Maybe<NotificationSettingsEventSubject>;
  frequency?: Maybe<NotificationSettingsFrequency>;
  id: Scalars['ID'];
  transport?: Maybe<NotificationSettingsTransport>;
};

export type UserNotificationSettingsInput = {
  enabled: Scalars['Boolean'];
  id: Scalars['String'];
};

export type UserPost = {
  __typename?: 'UserPost';
  addedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  ideaId?: Maybe<Scalars['ID']>;
  userId?: Maybe<Scalars['Int']>;
};

export type UserRanking = {
  __typename?: 'UserRanking';
  calculateDate?: Maybe<Scalars['DateTime']>;
  challengeId?: Maybe<Scalars['ID']>;
  communityId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  position?: Maybe<Scalars['Int']>;
  score: Scalars['Int'];
  user?: Maybe<User>;
  userId: Scalars['ID'];
};

export type UserSearchFilters = {
  country?: Maybe<Array<Scalars['String']>>;
  initial?: Maybe<Scalars['String']>;
  searchText?: Maybe<Scalars['String']>;
  userFields?: Maybe<Scalars['String']>;
  userFieldType?: Maybe<Scalars['String']>;
};

export type UserSearchResult = {
  __typename?: 'UserSearchResult';
  userBatch?: Maybe<Array<User>>;
  userCount?: Maybe<Scalars['Int']>;
};

export type UserSession = {
  __typename?: 'UserSession';
  email?: Maybe<Scalars['String']>;
  expiry: Scalars['DateTime'];
  id: Scalars['Int'];
  pkey: Scalars['String'];
  userId: Scalars['Int'];
};

export type UserSettingsResponseType = {
  __typename?: 'UserSettingsResponseType';
  code?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  userSettings?: Maybe<Array<UserNotificationSettings>>;
};

export type UserType = {
  __typename?: 'UserType';
  canModerate: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UserWithModerationStatus = {
  __typename?: 'UserWithModerationStatus';
  canModerate: Scalars['Boolean'];
  user: User;
};

export type Useroid = {
  __typename?: 'Useroid';
  id: Scalars['ID'];
  provider?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
};

export type UsersAndGroups = {
  __typename?: 'UsersAndGroups';
  groups?: Maybe<Array<UserGroup>>;
  users?: Maybe<Array<User>>;
};

export type Vote = {
  __typename?: 'Vote';
  average?: Maybe<Scalars['Float']>;
  date: Scalars['DateTime'];
  id: Scalars['ID'];
  milestoneId?: Maybe<Scalars['ID']>;
  parentId: Scalars['ID'];
  phase?: Maybe<Scalars['String']>;
  scorecardId?: Maybe<Scalars['ID']>;
  type: VotingType;
  userId: Scalars['ID'];
};

export type VoteAndCommentResultItemType = {
  __typename?: 'VoteAndCommentResultItemType';
  challengeCreatedAt: Scalars['DateTime'];
  challengeId: Scalars['Int'];
  challengeTitle: Scalars['String'];
  commentCount: Scalars['Int'];
  voteCount: Scalars['Int'];
};

export type VoteAndCommentResultType = {
  __typename?: 'VoteAndCommentResultType';
  count: Scalars['Int'];
  rows: Array<VoteAndCommentResultItemType>;
};

export type VoterInput = {
  id?: Maybe<Scalars['String']>;
  milestoneId: Scalars['String'];
  type: Scalars['String'];
  voterId: Scalars['String'];
};

export type Voting = {
  __typename?: 'Voting';
  isBlind?: Maybe<Scalars['Boolean']>;
  options?: Maybe<VotingOptions>;
  scorecards?: Maybe<ScorecardsAndLabels>;
  showVoters?: Maybe<Scalars['Boolean']>;
  type?: Maybe<VotingType>;
  wallet?: Maybe<VotingWallet>;
};

export type VotingInput = {
  isBlind?: Maybe<Scalars['Boolean']>;
  options?: Maybe<VotingOptionsInput>;
  scorecards?: Maybe<ScorecardsAndLabelsInput>;
  showVoters?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
  wallet?: Maybe<VotingWalletInput>;
};

export type VotingOptions = {
  __typename?: 'VotingOptions';
  maxScore?: Maybe<Scalars['Int']>;
  maxStars?: Maybe<Scalars['Int']>;
  minimumRatings?: Maybe<Scalars['Int']>;
};

export type VotingOptionsInput = {
  maxScore?: Maybe<Scalars['Int']>;
  maxStars?: Maybe<Scalars['Int']>;
  minimumRatings?: Maybe<Scalars['Int']>;
};

export enum VotingType {
  POINTSAWARD = 'POINTSAWARD',
  SCORECARD = 'SCORECARD',
  STARS = 'STARS',
  UP = 'UP',
  UPDOWN = 'UPDOWN'
}

export type VotingWallet = {
  __typename?: 'VotingWallet';
  allowance?: Maybe<Scalars['Int']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
};

export type VotingWalletInput = {
  allowance?: Maybe<Scalars['Int']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
};
